export default "__VITE_ASSET__cumN5TE4__"